import React from 'react';

// Leads
export const VENUE_SETTINGS_LEAD = 'venue_settings';
export const SPONSORS_LEAD = 'sponsors';
export const BOOTHS_LEAD = 'booths';
export const BRANDING_LEAD = 'branding';

export const SHOW = 'SHOW';
export const HIDE = 'HIDE';
export const ATTRACT = 'ATTRACT';

export const ATTENDEE_LIST_TEMPLATE_URL =
    'https://airmeet-files.s3.ap-south-1.amazonaws.com/templates/sample_attendee_list_v2.csv';

export const CUSTOM_REGISTRATION_DEFAULT_SAMPLE_ATTENDEE_LIST =
    'https://airmeet-files.s3.ap-south-1.amazonaws.com/templates/custom_registration_default_sample_attendee_list_v2.csv';

// AIRMEET EVENT AND SESSION STATUS
export const STATUS_CREATED = 'CREATED';
export const STATUS_ONGOING = 'ONGOING';
export const STATUS_PAUSED = 'PAUSED';
export const STATUS_FINISHED = 'FINISHED';

export const getEventEntryAccessOptions = (hideAuthProviders = false) => ({
    email: {
        value: 'email',
        label: 'Anyone can enter via their unique link',
        desc:
            'People can enter the event hassle-free without requiring OTP or sign in. The unique event access link will be sent to the email address provided by the registrant.',
        infoText: (
            <>
                <p>
                    Use this to verify the identity of attendees and manage
                    abuse effectively.
                </p>
                <p>
                    Please note that the registration shall be completed only
                    when he/she clicks on the unique link.
                </p>
            </>
        ),
        entryType: 'EMAIL_AUTHENTICATION',
        icon: 'mail',
        recommended: true,
    },
    invitation: {
        value: 'invitation',
        label: 'Only invited people can enter',
        desc:
            'People on the participant list can enter the event after clicking on the unique link sent to their email address.',
        infoText: (
            <>
                <p>Use this when you have prepared a list of invitees.</p>
                <p>
                    Please note that the registration shall be completed only
                    when he/she clicks on the unique link.
                </p>
            </>
        ),
        entryType: 'CSV_UPLOAD',
        icon: 'lock_shield',
    },
    domain: {
        value: 'domain',
        label: 'Only people from a specific domain can enter',
        desc:
            'People with email IDs from a specific domain address can enter the event after clicking on the unique link sent to their email address.',
        infoText:
            'Use this when inviting employees from your organization to an event.',
        entryType: 'DOMAIN_RESTRICTED',
        icon: 'union',
    },
    login: {
        value: 'login',
        label: 'Anyone can enter after sign in',
        desc: `People can enter the event after signing in with ${
            hideAuthProviders
                ? ''
                : 'either Google, LinkedIn, Facebook, Twitter, Apple ID or'
        } Airmeet login.`,
        infoText:
            'Use this to verify the identity of attendees and keep them signed-in to the event.',
        entryType: 'LOGIN_BASED',
        icon: 'safe',
    },
    link: {
        value: 'link',
        label: 'Anyone can enter without sign in',
        desc:
            'People can enter the event link without any authentication. The email addresses of the attendees might not be captured. It is recommended NOT to change this access rule after event has started to avoid potential attendee experience issues.',
        infoText:
            'Please note that it will not be possible to verify the identity of attendees through this method. Hence customization and access to multiple features will be restricted for security reasons.',
        entryType: 'PUBLIC',
        icon: 'globe',
    },
});

export const SPECIFIC_DOMAIN = 'Only people from a specific domain can enter';

// Cut off dates
export const CUT_OFF_DATE_OLD_DASHBOARD =
    process.env.REACT_APP_ENV === 'production' ? '2022-05-26' : '2022-01-01';
export const CUT_OFF_DATE_RECORDINGS = '2020-12-02';
export const CUT_OFF_DATE_AUDIENCE = '2022-02-09';

export const NEW_DASH_BANNER_DURATION =
    process.env.REACT_APP_ENV === 'production' ? 24 : 1;
export const NEW_DASH_BANNER_UNIT =
    process.env.REACT_APP_ENV === 'production' ? 'hours' : 'minutes';

export const SHOW_RECORDINGS_FOR_ALL_AIRMEETS = JSON.parse(
    process.env.REACT_APP_SHOW_RECORDINGS_FOR_ALL_AIRMEETS || false
);

// GUIDELINES FOR UPLOADING A BACKDROP
export const BACKDROP_GUIDELINES_LINK =
    'https://airmeet-files.s3.ap-south-1.amazonaws.com/Stage-Backdrop/Airmeet+Stage+Backdrop+Guidelines.pdf';
export const SESSION_TYPE_HOSTING = 'HOSTING';
export const SESSION_TYPE_STREAMING = 'STREAMING';
export const SESSION_TYPE_BOOTH = 'BOOTH';
export const STREAMING_HELP_URL =
    'https://help.airmeet.com/support/solutions/articles/82000443829-how-to-stream-in-your-events-into-airmeet-via-rtmp-input-';
